import React from "react";
import styled from "styled-components";

import { ExportWarning } from "../../api/LCSModels";

import Color from "../../resources/colors";
import WarningIcon from "../../resources/images/warning-icon.png";
import CloseIcon from "../../resources/images/close-icon.png";

import { HFlex, VFlex, IconButton } from "../../pandora/styled";
import { FadeAnimation } from "../../pandora/animations";


const Container = styled(VFlex)`
    margin-top: 20px;
    padding: 15px;
    box-sizing: border-box;

    border: 1px solid ${Color.yellow};
    border-radius: 5px;
    background-color: ${Color.extraDarkGrey};

    animation: ${FadeAnimation} 0.5s ease 1;

    .icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
    }
`

const Table = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    max-height: 400px;
    margin-top: 15px;
    overflow-y: auto;

    h5 {
        padding: 5px 10px;
        font-weight: normal;
        border-bottom: 1px solid ${Color.lightGrey};
        word-break: break-word;
    }

    .header {
        position: sticky;
        top: 0;
        font-weight: bold;
        background-color: ${Color.lightGrey};
    }
`

interface ExportWarningPanelProps {
    message: string;
    warnings: ExportWarning[];
    onClose: () => void;
}

/**
 * Lists the track links an export included or left out with warnings.
 */
const ExportWarningPanel = (props: ExportWarningPanelProps): React.ReactElement => {

    const { message, warnings } = props;

    return (
        <Container>
            <HFlex style={{justifyContent: "space-between", alignItems: "center"}}>
                <HFlex style={{alignItems: "center"}}>
                    <img className="icon" src={WarningIcon} />
                    <h4>{message}</h4>
                </HFlex>
                <IconButton
                    color=      {Color.lightGrey}
                    hoverColor= {Color.extraLightGrey}
                    icon=       {CloseIcon}
                    onClick=    {props.onClose}
                    style=      {{marginRight: 0}}
                >Dismiss</IconButton>
            </HFlex>
            <Table>
                <h5 className="header">Track link</h5>
                <h5 className="header">Problem</h5>
                {warnings.map((warning, index) =>
                    <React.Fragment key={index}>
                        <h5>{warning.trackLink}</h5>
                        <h5>{warning.message}</h5>
                    </React.Fragment>
                )}
            </Table>
        </Container>
    )
}

export default ExportWarningPanel;
